import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    isSos: false,
    dataOnSos: null,
    listDataSos: null,
    itemSos: null,
  },
  mutations: {
    SET_IS_SOS(state, isSos) {
      state.isSos = isSos
    },
    SET_DATA_ON_SOS(state, data) {
      state.dataOnSos = data
    },
    SET_LIST_DATA_SOS(state, data) {
      state.listDataSos = data
    },
    SET_ITEM_SOS(state, data) {
      state.itemSos = data
    },
  },
  actions: {
    async init({ rootState, state, commit }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/sos`,
          method: 'POST',
          data: data
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200 || res.status === 201) {
        state.isSos = true
        // state.dataOnSos = res.data
        commit('SET_DATA_ON_SOS', res.data)
      }
    },
    async getIsSos({ rootState, commit }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/sos/on_sos`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      // console.log('res getIsSos : ', res)
      if (res.status === 200) {
        commit('SET_IS_SOS', res.data.on_sos)
        commit('SET_DATA_ON_SOS', res.data.data)
      }
    },
    async getListDataSos({ rootState, state, commit }, { param, page = 1, pageSize = 10, isLoadMore = false }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/sos`,
          method: 'GET',
          params: {
            ...param,
            page: page,
            rows: pageSize,
          },
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        const results = res.data.results || []

        if (isLoadMore) {
          const newList = [...state.listDataSos, ...results]
          await commit('SET_LIST_DATA_SOS', newList)
        } else {
          await commit('SET_LIST_DATA_SOS', results)
        }
        return { results, status: 'success' };
      } else {
        return { results: [], status: 'error' };
      }
    },
    async getItemSos({ rootState, commit }, idSos) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/sos/${idSos}`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        //console.log('res data : ', res.data)
        commit('SET_ITEM_SOS', res.data)
      }
    },
    async actionSos({ rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/sos/${data.idSos}/do`,
          method: 'POST',
          data: data.data
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        return true;
      }
    },
    async updateDataSos({ rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/sos/${data.idSos}`,
          method: 'PATCH',
          data: data.data
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        return
      }
    },
    async sendNotes({ rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/sos/${data.idSos}`,
          method: 'PATCH',
          data: data.notes
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        return
      }
    },
  }
})
